module.exports = __webpack_public_path__ + "img/31.82361cde.jpg";